// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__xjlWe"};
module.exports.__checksum = "5181b76c3e21"
